export default "__VITE_ASSET__hfMcrLTl__"